import React from 'react';

const SouthDakota = () => (
  <svg
    width="93"
    height="61"
    viewBox="0 0 93 61"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M91.2679 60.542C88.5364 57.2962 84.3475 56.7118 82.4818 54.9938C80.9612 55.6416 78.7928 55.1698 76.8497 55.5078C75.3995 55.7613 74.7236 55.9232 73.7802 56.5287C72.9073 56.0711 71.3655 55.719 70.1968 54.9938C69.176 54.3601 68.4579 53.1491 67.6342 52.9449C65.4658 52.4168 62.7061 53.0435 60.4673 52.9449C41.5575 52.1 17.9801 51.5015 0.0629883 49.8751C0.414995 32.646 2.6608 17.318 3.64641 0.722656C31.4761 2.92645 60.4885 3.94738 90.6695 3.79248C90.9511 6.97496 87.9661 6.89047 87.6 9.42519C88.4449 10.2912 88.7124 11.7276 89.6487 12.495C90.3035 13.3751 92.0846 13.1287 92.2043 14.5439C92.5211 23.9576 91.5566 34.6456 92.7182 43.2144C92.9364 45.7562 91.1835 43.5031 90.6695 44.7493C90.3738 45.9322 91.6974 46.2631 91.6974 47.3122C91.6974 48.2134 91.0356 48.3683 91.6974 49.8751C92.0424 50.6566 92.2817 53.2547 91.6974 54.9938C91.4228 55.7965 89.9655 57.3807 91.099 58.4931L91.2679 60.542Z"
      fill="#FC374D"
    />
  </svg>
);

export default SouthDakota;
